import { useQueryClient } from '@tanstack/react-query';

const useReload = (...args: Parameters<ReturnType<typeof useQueryClient>['refetchQueries']>) => {
  const queryClient = useQueryClient();
  return () => queryClient.refetchQueries(...args);
};

export default useReload;
